

const DEFAULT_VERSION = 'beta';
export const VERSION = typeof "3.3.3" !== 'undefined' ? "3.3.3" : DEFAULT_VERSION;
if (typeof "3.3.3" === 'undefined') {
  console.error('loaders.gl: The __VERSION__ variable is not injected using babel plugin. Latest unstable workers would be fetched from the CDN.');
}
//# sourceMappingURL=version.js.map